
<iframe *ngIf="link != null;else elseBlock;" [src]="link" width="100%" height="100%">
  </iframe>
<ng-template #elseBlock>
  <div class="notSelected">
    <h2>No File Selected</h2>
    </div>
</ng-template>
